import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-asset',
  templateUrl: './icon-asset.component.html',
  styleUrls: []
})
export class IconAssetComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
